import React, { FC } from 'react'
import Icon from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

export type TWhAntdIconProps = Pick<Partial<CustomIconComponentProps>, 'style'>

export const createAntdIcon =
  (Svg: FC) => (props: Partial<CustomIconComponentProps>) =>
    <Icon component={Svg} {...props} />
